import React, { useState, useRef, useEffect } from "react";
import HighResMarketingImg from "assets/images/high-res-marketing.png";
import HighResImg from "assets/images/highres.png";
import "./index.scss";
import Button from "components/Button";

const HighResMarketingContainer = () => {
  const introRef = useRef(null);
  const howRef = useRef(null);
  const bestRef = useRef(null);
  const [activeSection, setActiveSection] = useState("introduction");

  const changeNavBg = () => {
    if (window.scrollY > 911) {
      setActiveSection("introduction");
    }
    if (window.scrollY > 1400) {
      setActiveSection("how");
    }
    if (window.scrollY > 2400) {
      setActiveSection("best");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNavBg);
    return () => {
      window.removeEventListener("scroll", changeNavBg);
    };
  }, []);
  return (
    <div className="high-res-marketing">
      <section className="hero-wrapper">
        <img src={HighResMarketingImg} className="image" alt="hero" />
        <p className="text">Guides & Resources</p>
      </section>
      <section className="introduction-section">
        <h1 className="headline">High Resolution Imagery</h1>
        <h2 className="description">
          Allows you to be more certain about what is happening in your fields.
        </h2>
        <Button type="outlined" color="green" label="Get Started" />
      </section>
      <section className="social-proof">
        <div className="proof-wrapper">
          <h3 className="text">
            “With this valuable information at hand, you can be making better
            decisions about your crop and ensure it will grow the best that it
            can.”
          </h3>
        </div>
      </section>
      <section className="content-wrapper">
        <div className="content-container">
          <article
            className="article-container"
            id="introduction-content"
            ref={introRef}
          >
            <h3 className="title">Introduction</h3>
            <p className="copywrite">
              Ideal for monitoring in-season crop variability and performance,
              high resolution satellite imagery can detect issues that are
              difficult to spot at ground-level. Supplemented with use of our
              free 10m satellite maps and your usual ground-truthing, high
              resolution images are an extremely handy tool for helping you make
              decisions.
            </p>
          </article>
          <article className="article-container" id="how-content" ref={howRef}>
            <h3 className="title">How it works</h3>
            <div className="copywrite">
              The whole process is simple. We show you how well the plant is
              growing using different Indices like NDVI (Normalised difference
              vegetation index). The NDVI provides you with markers to indicate
              crop vigour and health. Remember,{" "}
              <b className="bold">
                the higher the NDVI, the greater the vigour and health of the
                plant/tree.
              </b>{" "}
              Colours are deliberately stretched to allow you to pin-point good
              to poor performing areas on a particular day (not the overall
              season) that the naked eye often can&lsquo;t detect:
              <ul className="list-wrapper">
                <li className="list-item">Good - Blue</li>
                <li className="list-item">Average - Green</li>
                <li className="list-item">Fair - Yellow</li>
                <li className="list-item">Poor - Red</li>
              </ul>
              <img
                src={HighResImg}
                className="highres-content"
                alt="highres-content"
              />
              A red spot does not necessarily indicate a bad area, plant, or
              tree. It is a sign that you need to either monitor the area or
              take some affirmative action. Low value may indicate poor health
              and vigour due to:
              <ul className="list-wrapper">
                <li className="list-item">Nutrient deficiency</li>
                <li className="list-item">Presence of disease or pests</li>
                <li className="list-item">
                  Poorer growing conditions (soil type/compaction, elevation,
                  and drainage)
                </li>
                <li className="list-item">Frost or Hail damage</li>
              </ul>
            </div>
          </article>
          <article
            className="article-container"
            id="best-content"
            ref={bestRef}
          >
            <h3 className="title">Best time to order</h3>
            <p className="copywrite">
              As images are captured on-demand from a satellite provider, they
              take <b className="bold">10-14 days</b> from order to delivery. We
              highly recommend you plan ahead so you can access images during
              critical periods. If you would like to view high resolution
              imagery from a time that occurred in the past, please contact us
              through
              <a href="mailto:support@datafarming.com.au" className="link">
                support@datafarming.com.au
              </a>{" "}
              and we&lsquo;ll find the right imagery to match your needs.
            </p>
          </article>
        </div>
        <ul className="content-navigation">
          <a
            className={`navigation-item ${
              activeSection === "introduction" ? "-active" : ""
            }`}
            id="introduction"
            onClick={(e) => {
              setActiveSection(e.target.id);
            }}
            href="#introduction-content"
            aria-hidden
          >
            Introduction
          </a>
          <a
            className={`navigation-item ${
              activeSection === "how" ? "-active" : ""
            }`}
            id="how"
            onClick={(e) => {
              setActiveSection(e.target.id);
            }}
            href="#how-content"
            aria-hidden
          >
            How it works
          </a>
          <a
            className={`navigation-item ${
              activeSection === "best" ? "-active" : ""
            }`}
            id="best"
            onClick={(e) => {
              setActiveSection(e.target.id);
            }}
            href="#best-content"
            aria-hidden
          >
            Best time to order
          </a>
        </ul>
      </section>
      <section className="footer-container">
        <div className="footer-wrapper">
          <p className="text">
            © 2022 Datafarming Pty Ltd - Australia. All rights reserved.
          </p>
        </div>
      </section>
    </div>
  );
};

export default HighResMarketingContainer;
